exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[data-v-edfc44b6]{border-color:#e0e0e0}", ""]);

// exports
